import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Row,
  Col
} from "reactstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { useFetch2 } from "components/utils/authenticatedHook";
import Swal from 'sweetalert2';
import { pasteValue } from "../../Reusable/OnPasteValue";
import getDeviceType from "helpers/getDeviceTypeHelper";
import {deviceType} from "constants/general.constant";
const _ = require("lodash");

const defaultSorted = [
  {
    dataField: "createdAt", // if dataField is not match to any column you defined, it will be ignored.
    order: "desc" // desc or asc
  }
];

const MySearch = props => {
  let input;
  const handleClick = () => {
    props.onSearch(input.value);
  };
  return (
    <div>
      <div class="form-group">
        <input
          type="text"
          class="form-control input-date-filter"
          id="exampleInputName1Test"
          style={{ fontSize: "20px" }}
          placeholder="Search Name, Email, etc..."
          ref={n => (input = n)}
          onChange={handleClick}
          onPaste={(e) => {
            e.preventDefault();
            const event = pasteValue(e)
            handleClick({ target: { value: event.target.value } });
          }}
        />
      </div>
    </div>
  );
};
const MyExportCSV = (props) => {
  const handleClick = () => {
    props.onExport();
  };
  return (
    <Row>
      <Col>
        <button className="btn btn-info ml-2 download-click-cls float-left" onClick={handleClick}>
        <i class="mdi mdi-download" style={{
                fontSize: 20
        }}></i> Export to CSV
        </button>
      </Col>
    </Row>
  );
};
const ClientList = (props, context) => {
  const title = props.title ? props.title : "Client";
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2(null);
  
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {"   "}Showing {from} to {to} of {size} Results
    </span>
  );  
  function diactivate(cell, row) {
    if (row.isActive) {
      return (
        <button
          type="button"
          className="btn btn-info ml-2 inactive-note-click"
          onClick={() => {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to deactivate this client; if so, this client portal's all patients, staff, and care providers are deactivated!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, DeActivate it!'
            }).then((result) => {
              //console.log(row);
              if (result.isConfirmed) {   
                props.reloadApi();            
                doFetch({
                  url: "/client-action/" + row._id + "?enable=false",
                  method: "PUT"
                });                
              }
            })          
          }}
        >
          <i class="mdi mdi-account-remove" style={{color:"white"}}></i> DeActivate
        </button>
      );
    } else {
      return (
        <button
          type="button"
          className="btn btn-info ml-2 active-note-click"
          onClick={() => {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to activate this client; if so, this client portal's all patients, staff, and care providers are activated!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Activate it!',
            }).then((result) => {
              //console.log(row);
              if (result.isConfirmed) {
                props.reloadApi();
                doFetch({
                  url: "/client-action/" + row._id + "?enable=true",
                  method: "PUT"
                });
              }
            })
          }}
        >
          <i class="mdi mdi-account-check"></i> Activate
        </button>
      );
    }
  }
  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "All",
        value: props.usersGivenAccessMyReading.length
      }
    ] // A numeric array is also available. the purpose of above example is custom the text
  };

  const device = getDeviceType();
  return (
    <ToolkitProvider
      keyField="_id"
      data={props.usersGivenAccessMyReading}
      columns={[
        {
          dataField: "organization",
          text: title + " Organization",
          sort: true,
          formatter: (cell, row) => {
            return (
              <div>
                {row.websiteLogo && (
                  <img
                    src={row.websiteLogo}
                    className="img-thumbnail"
                    alt="image"
                  ></img>
                )}

                <span className="text-center"> {cell}</span>
                <span className="text-center">
                  {" "}
                  {row.isSubClient ? " (Subclient)" : ""}
                </span>
              </div>
            );
          }
        },
        {
          dataField: "email",
          text: "Email Address",
          sort: true
        },
        {
          dataField: "username",
          text: "Username",
          sort: true
        },

        {
          dataField: "phone",
          text: "Phone",
          sort: true
        },
        {
          dataField: "country",
          text: "Country",
          sort: true
        },
        {
          dataField: "region",
          text: "Region",
          sort: true
        },
        {
          dataField: "usage",
          text: "Usage",
          sort: true
        },
        {
          dataField: "",
          text: "Action",
          formatter: diactivate,          
          sort: false,
          csvExport: false
        }
      ]}
      search 
      exportCSV={{ fileName: "Clients.csv" }}
    >
      {toolKitProp => (
        <div>
          <div>
            <Row className={`mt-3`}>
              <Col md={device === deviceType.tablet ? 6 : 10}>
                <MySearch {...toolKitProp.searchProps} />
              </Col>
              <Col md={device === deviceType.tablet ? 3 : 2}>
                <MyExportCSV {...toolKitProp.csvProps}> 
                  Export CSV
                </MyExportCSV>
              </Col>
            </Row>
          </div>
          <div className="scrollbar-table-cls">
          <BootstrapTable
            wrapperClasses="table-responsive"
            {...toolKitProp.baseProps}
            noDataIndication="No Data Found"
            defaultSorted={defaultSorted}
            //expandRow={expandRow}
            pagination={paginationFactory(options)}
          />
          </div>
        </div>
      )}
    </ToolkitProvider>
  );
};

export default ClientList;
